import { useFileSignedUrl } from "@/api/services/global/file";
import { EMPTY_STR } from "@/constants/string";
import ImageIcon from "@mui/icons-material/Image";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { FC, useState } from "react";

type TImagePreviewCellProps = {
  filePath?: string | null;
  alt?: string;
};

// Table cell showing an image icon; click fetches a signed URL for the S3 path and previews it in a modal
export const ImagePreviewCell: FC<TImagePreviewCellProps> = ({ filePath, alt = "画像" }) => {
  // Holds the path only while the modal is open, so the query runs on demand instead of on every row render
  const [openedPath, setOpenedPath] = useState<string | null>(null);
  const { data, isLoading } = useFileSignedUrl(openedPath);
  const previewImageUrl = data?.data.signedUrl;

  if (!filePath) return <>{EMPTY_STR.TEXT}</>;

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <IconButton
          size="small"
          aria-label={alt}
          onClick={(e) => {
            e.stopPropagation();
            setOpenedPath(filePath);
          }}
          sx={{ p: 0, color: "primary.main", "&:hover": { bgcolor: "transparent" } }}
        >
          <ImageIcon sx={{ fontSize: 20 }} />
        </IconButton>
      </Box>

      <Modal open={Boolean(openedPath)} onClose={() => setOpenedPath(null)} aria-label={alt}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            outline: "none",
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            p: 1,
            maxWidth: "90vw",
            maxHeight: "90vh",
          }}
        >
          {isLoading ? (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth: 200, minHeight: 150 }}>
              <Typography variant="body14" color="text.secondary">
                読み込み中...
              </Typography>
            </Box>
          ) : previewImageUrl ? (
            <Box component="img" src={previewImageUrl} alt={alt} sx={{ display: "block", maxWidth: "100%", maxHeight: "80vh", borderRadius: 1 }} />
          ) : (
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minWidth: 200, minHeight: 150 }}>
              <Typography variant="body14" color="text.secondary">
                画像を読み込めません
              </Typography>
            </Box>
          )}
        </Box>
      </Modal>
    </>
  );
};
